export const ImageAspectRatioPresets = {
    square: 1,
    cinema: 16 / 9,
    landscape: 4 / 3,
};
export const ImageFocalPointPresets = {
    topLeft: { x: 0, y: 0 },
    topCenter: { x: 50, y: 0 },
    topRight: { x: 100, y: 0 },
    centerLeft: { x: 0, y: 50 },
    center: { x: 50, y: 50 },
    centerRight: { x: 100, y: 50 },
    bottomLeft: { x: 0, y: 100 },
    bottomCenter: { x: 50, y: 100 },
    bottomRight: { x: 100, y: 100 },
};
export var ImageResizeOptions;
(function (ImageResizeOptions) {
    ImageResizeOptions["contain"] = "contain";
    ImageResizeOptions["cover"] = "cover";
})(ImageResizeOptions || (ImageResizeOptions = {}));
export var ImageHoverEffectOptions;
(function (ImageHoverEffectOptions) {
    ImageHoverEffectOptions["none"] = "none";
    ImageHoverEffectOptions["zoom"] = "zoom";
    ImageHoverEffectOptions["darken"] = "darken";
})(ImageHoverEffectOptions || (ImageHoverEffectOptions = {}));
export var ImageLoadingBehaviorOptions;
(function (ImageLoadingBehaviorOptions) {
    ImageLoadingBehaviorOptions["none"] = "none";
    ImageLoadingBehaviorOptions["blur"] = "blur";
    ImageLoadingBehaviorOptions["spinner"] = "spinner";
})(ImageLoadingBehaviorOptions || (ImageLoadingBehaviorOptions = {}));
//# sourceMappingURL=types.js.map